import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const Wrapper = styled(Box).attrs({ as: 'ul' })({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridAutoRows: '1fr',
  padding: 0,
  listStyle: 'none',
  gap: 16,
  marginBottom: 32,

  [`@media (min-width: 1000px)`]: {
    gridTemplateColumns: 'unset',
    gridAutoColumns: 'minmax(0, 1fr)',
    gridAutoFlow: 'column',
  },
});
